module.exports = __webpack_public_path__ + "img/comp-table-interaction-resp-time-wh-split.377e9097.png";